import { MenuService } from './interactorTypes';
import MenuApiService from './MenuApiService';
import { Menu } from './types';

export default class MenuApiInteractor implements MenuService {
  public constructor(private menuApiService: MenuApiService) {}

  public getMenuData(): Promise<Menu | undefined> {
    return this.menuApiService.getMenuData();
  }
}
